module.exports = __webpack_public_path__ + "static/bootstrap-badge-pills-f6273c57bf8a644ab86ff46188ff9d7a.png";